<template lang="pug">
    v-container.text-center(fluid)
        pie-chart.pa-10(:chart-data="datacollection" :options="options")
        v-btn(color="primary" @click="fillData()") Randomize
</template>

<script>
    import PieChart from '@/plugins/charts/PieChart.js'

    export default {
        components: {
            PieChart
        },
        data () {
            return {
                    datacollection:{

                        datasets: [
                        {
                            data: [this.getRandomInt(),this.getRandomInt(), this.getRandomInt()],
                            backgroundColor: [
                                `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.2)`,
                                `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.2)`,
                                `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.2)`
                            ]
                        }
                    ]
                },
                options:{
                    responsive:true
                }
            }
        },
        mounted () {
            this.fillData()
        },

        methods: {
            fillData () {
                this.datacollection = {

                    labels: ['Primero', 'Segundo', 'Tercero'],
                    datasets: [
                        {
                            data: [this.getRandomInt(),this.getRandomInt(), this.getRandomInt()],
                            backgroundColor: [
                                `rgba(${Math.floor((Math.random() * 255) + 100)}, ${Math.floor((Math.random() * 255) + 100)}, ${Math.floor((Math.random() * 255) + 100)}, 1)`,
                                `rgba(${Math.floor((Math.random() * 255) + 100)}, ${Math.floor((Math.random() * 255) + 100)}, ${Math.floor((Math.random() * 255) + 100)}, 1)`,
                                `rgba(${Math.floor((Math.random() * 255) + 100)}, ${Math.floor((Math.random() * 255) + 100)}, ${Math.floor((Math.random() * 255) + 100)}, 1)`
                            ]
                        }
                    ],
                }
            },
            getRandomInt () {
                return Math.floor(Math.random() * (50 - 5 + 1)) + 5
            }
        }
    }
</script>
